import { notifications } from '@mantine/notifications';
import {
  getPaymentChannelKey,
  getPaymentChannelsKey,
  useGetPaymentChannel,
  useUpdatePaymentChannel,
} from 'api-hooks/payment-channel';
import { queryClient } from 'common/repositories/query-client';
import { useRouter } from 'next/router';

import PaymentChannelForm from './components/form';

export default function PaymentChannelView() {
  const { query } = useRouter();
  const id = query.id as string;
  const queryView = useGetPaymentChannel({ id }, { enabled: !!id });
  const updateMutation = useUpdatePaymentChannel();

  return (
    <PaymentChannelForm
      query={queryView}
      saveMutation={updateMutation}
      onSubmit={async (input) => {
        const result = await updateMutation.mutateAsync({
          body: input,
          paymentChannelId: id,
        });
        queryClient.refetchQueries(getPaymentChannelsKey());
        queryClient.refetchQueries(getPaymentChannelKey());
        notifications.show({ message: result.message, color: 'green' });

        return result.data;
      }}
    />
  );
}
